export default "__VITE_ASSET__CTqxKXUi__"